import { createAction, props } from '@ngrx/store';

import {
  DocRenameRequest,
  DocumentDuplicateResponse,
  WorkspaceItem,
  WorkspaceMoveRequest
} from '@primatoo-ms-organization';
import { ValidateDocumentRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/ValidateDocumentRequest';
import {
  CreateGlobalMeasureDocRequest
} from 'it/primatoo/openapi/api/org/schemas/globalmeasurecheckdoc/CreateGlobalMeasureDocRequest';
import { UpdateDocResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/UpdateDocResponse';
import {
  UpdateGlobalMeasureDocRequest
} from 'it/primatoo/openapi/api/org/schemas/globalmeasurecheckdoc/UpdateGlobalMeasureDocRequest';

// RISK ASSESSMENT
export const createRiskAssessment = createAction('[RiskAssessment] Create RiskAssessment', props<{
  request: CreateGlobalMeasureDocRequest
}>());
export const createRiskAssessmentSuccess = createAction('[RiskAssessment] Create RiskAssessment Success', props<{
  id: number
}>());
export const createRiskAssessmentFailed = createAction('[RiskAssessment] Create RiskAssessment Failed', props<{
  error: unknown
}>());

export const updateRiskAssessment = createAction('[RiskAssessment] Update Risk Assessment', props<{
  id: number,
  request: UpdateGlobalMeasureDocRequest
}>());
export const updateRiskAssessmentSuccess = createAction('[RiskAssessment] Update Risk Assessment Success', props<{
  response: UpdateDocResponse
}>());
export const updateRiskAssessmentFailed = createAction('[RiskAssessment] Update Risk Assessment Failed', props<{
  error: unknown
}>());

export const renameRiskAssessment = createAction('[folder] Rename Risk Assessment', props<{
  id: number,
  request: DocRenameRequest
}>());
export const renameRiskAssessmentSuccess = createAction('[folder] Rename Risk Assessment Success', props<{
  id: number
}>());
export const renameRiskAssessmentFailed = createAction('[folder] Rename Risk Assessment Failed', props<{
  error: unknown
}>());

export const publishRiskAssessmentWithConfirm = createAction('[RiskAssessment] Publish Risk Assessment with confirm', props<{
  docId: number,
  skipBack?: boolean,
  hideInfo?: boolean
}>());
export const publishRiskAssessment = createAction('[RiskAssessment] Publish Risk Assessment', props<{
  docId: number,
  skipBack?: boolean
}>());
export const publishRiskAssessmentSuccess = createAction('[RiskAssessment] Publish Risk Assessment Success');
export const publishRiskAssessmentFailed = createAction('[RiskAssessment] Publish Risk Assessment Failed', props<{
  error: unknown
}>());

export const moveRiskAssessment = createAction('[RiskAssessment] Move RiskAssessment', props<{
  id: number,
  workspaceMoveRequest: WorkspaceMoveRequest
}>());
export const moveRiskAssessmentSuccess = createAction('[RiskAssessment] Move RiskAssessment Success', props<{
  item: WorkspaceItem
}>());
export const moveRiskAssessmentFailed = createAction('[RiskAssessment] Move RiskAssessment Failed', props<{
  error: unknown
}>());

export const duplicateRiskAssessment = createAction('[RiskAssessment] Duplicate RiskAssessment', props<{
  id: number,
  request: CreateGlobalMeasureDocRequest
}>());
export const duplicateRiskAssessmentSuccess = createAction('[RiskAssessment] Duplicate RiskAssessment success', props<{
  response: DocumentDuplicateResponse
}>());
export const duplicateRiskAssessmentFailed = createAction('[RiskAssessment] Duplicate RiskAssessment failed', props<{
  error: unknown
}>());

export const deleteRiskAssessment = createAction('[RiskAssessment] Delete RiskAssessment', props<{ id: number }>());
export const deleteRiskAssessmentSuccess = createAction('[RiskAssessment] Delete RiskAssessment Success');
export const deleteRiskAssessmentFailed = createAction('[RiskAssessment] Delete RiskAssessment Failed', props<{
  error: unknown
}>());

export const reopenRiskAssessmentWithConfirm = createAction('[RiskAssessment] Reopen RiskAssessment with confirm', props<{
  id: number
}>());
export const reopenRiskAssessment = createAction('[RiskAssessment] Reopen RiskAssessment', props<{ id: number }>());
export const reopenRiskAssessmentSuccess = createAction('[RiskAssessment] Reopen RiskAssessment Success', props<{
  id: number
}>());
export const reopenRiskAssessmentFailed = createAction('[RiskAssessment] Reopen RiskAssessment Failed', props<{
  error: unknown
}>());
export const validateRiskAssessmentWithConfirm = createAction('[RiskAssessment] Validate document with confirm',
  props<{
    docId: number,
    skipBack?: boolean
  }>());
export const validateRiskAssessment = createAction('[RiskAssessment] Validate document',
  props<{ docId: number, request: ValidateDocumentRequest, skipBack?: boolean }>());
export const validateRiskAssessmentSuccess = createAction('[RiskAssessment] Validate document Success');
export const validateRiskAssessmentFailed = createAction('[RiskAssessment] Validate document Failed', props<{
  error: unknown
}>());
